

<div class="container">


  <h2 class="content-heading">
    Bible Books
  </h2>




<div class="blockX">


  <div class="block-contentX">

      <!-- <div class=row>

          <div class="col-sm-5">

            Show
            <select (change)="changeNumberOfRecords()" [(ngModel)]="numberOfRecords">
              <option value=15>15</option>
                <option value=30>30</option>
                <option value=60>60</option>
                <option value=99999>All</option>
            </select>
            entries
          </div>

          <div class="col-sm-7 text-right">
              Search: <input type="text" [(ngModel)]="search">
          </div>

        </div> -->


        <div class="table-responsive table yearDataTable" xclass="table table-striped table-vcenter table-sm">

            <div class="xrow header gridRow row">
                <div class="col-md-3">Name</div>
                <div class="col-md-3">Spoken Name</div>
                <div class="col-md-3">Alternate Name</div>
                <div class="col-md-2">Section</div>
                <div class="col-md-1">Actions</div>
            </div>

            <div id="scrollableTable">
                <div class="">
                  <div *ngFor="let obj of entities" class="dateRow gridRow row">

                  <div class="col-md-3">{{obj.Localized[0].Name}}</div>
                  <div class="col-md-3">{{obj.Localized[0].Description}}</div>
                  <div class="col-md-3"><span *ngIf="obj.Section.Localized">{{obj.Localized[0].AlternateName}}</span></div>
                  <div class="col-md-2"><span *ngIf="obj.Section.Localized">{{obj.Section.Localized[0].Name}}</span></div>
                  <div class="col-md-1">
                      <div class="btn-group">
                          <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="edit(obj)">
                              <i class="fa fa-pencil"></i>
                          </button>
                        </div>
                      </div>
                  </div>
                </div>
              </div>

          </div>



                  </div>



                  <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>
            </div>

          </div>

